// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1y0wNGL-6krop9 {\n  visibility: hidden;\n  position: absolute;\n  bottom: 10px;\n  left: 15px;\n  height: 32px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverPositioner": "_1y0wNGL-6krop9"
};
export default ___CSS_LOADER_EXPORT___;
